import React, { Component } from "react";
import FlipCountdown from "@rumess/react-flip-countdown";

class TimerBaisc extends Component {
  render() {
    return (
      <FlipCountdown
        size="small"
        theme="light"
        titlePosition="bottom"
        dayTitle="Days"
        hourTitle="Hours"
        minuteTitle="Minutes"
        secondTitle="Seconds"
        onTimeUp={() => console.log("Time's up ⏳! :) Celebrations started....Have fun Mr.Rakesh Chilukala")}
        hideYear
        hideMonth
        endAt={"2023-06-15"} // Date/Time
      />
    );
  }
}

export default TimerBaisc;
